// extracted by css-extract-rspack-plugin
export default {"assigneeFilterButton":"ListAssigneeFilter-module__assigneeFilterButton___xgtC"};